// The console gate asked for a second factor (spec/07 §6.6). A member with an authenticator proves
// it; one without sets one up here — enrolling needs their password, or a sign-in from the last ten
// minutes — and proves it with its first code, which steps the session up in the same call. The block
// itself is `TwoFactorSetup.tsx`, which accepting an invitation to a role that needs one uses too.

import { useTranslation } from '@clavian/i18n/react';
import { Button } from '@clavian/ui-web';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useApi } from '../api/client';
import { Mark } from '../shell/Mark';
import { useSecondFactorGate } from './second-factor-gate';
import { TwoFactorSetup } from './TwoFactorSetup';

export function StepUp() {
  const { t } = useTranslation('console');
  const api = useApi();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const gate = useSecondFactorGate();

  const proven = async () => {
    // A new session replaced the old one; everything read under the old one is read again.
    await queryClient.invalidateQueries();
    gate.satisfied();
  };
  const signOut = async () => {
    try {
      await api.signOut();
    } finally {
      queryClient.clear();
      gate.satisfied();
      await navigate({ to: '/sign-in' });
    }
  };

  return (
    <main className="console-centred" id="console-main">
      <Mark size={48} />
      <TwoFactorSetup headingLevel={1} onVerified={proven} />
      <p>
        <Button variant="ghost" onClick={() => void signOut()}>
          {t('secondFactor.signOut')}
        </Button>
      </p>
    </main>
  );
}
